import { getConfig } from "@/lib/config";

export interface TokenResult {
  accessToken: string;
  refreshToken?: string;
  expiresAt?: Date;
  platformAccountId: string;
  platformUsername: string;
  platformAvatarUrl?: string;
  scopes: string;
}

/**
 * Returns the app base URL with https enforced for non-localhost URLs.
 * Prevents OAuth redirect_uri_mismatch when NEXT_PUBLIC_APP_URL uses http://.
 */
export function getAppUrl(): string {
  const url = getConfig().app.url;
  if (url.includes("localhost") || url.includes("127.0.0.1")) return url;
  return url.replace(/^http:\/\//, "https://");
}
